import { useWorkspaceColorScheme } from './useWorkspaceColorScheme'

export const useHeaderTheme = () => {
  const { isLight } = useWorkspaceColorScheme()

  if (isLight) {
    return 'light'
  }

  return 'dark'
}
